import { c as _c } from "react/compiler-runtime";
import SceneLogo from "@assets/logo/SCENE_logo.svg?react";
import SphereXgLogo from "@assets/logo/sphere-xg-logo.svg?react";
import { Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { MEMBER_SEAT_DESCRIPTIONS, MEMBER_SEAT_LABELS } from "@utils/member-seats-utils";
/** The logo of each seat, as the members table shows it */
const SEAT_LOGOS = {
  xgSeat: SphereXgLogo,
  sceneSeat: SceneLogo
};

/** The size of the seat logos, which matches the logos in the members table */
const LOGO_SIZE = "24px";

/** The opacity of a faded logo, e.g. of a seat the member can neither get nor holds */
const FADED_LOGO_OPACITY = 0.5;

/** How far the first line is lowered to share one center line with the box of a checkbox */
const CHECKBOX_ALIGNMENT_OFFSET = 0.25;

/** The frame around a seat card, so that every seat card has the same outline and padding */
export const SEAT_CARD_FRAME_SX = {
  p: 1.5,
  border: 1,
  borderRadius: 1,
  borderColor: "divider"
};
/**
 * The content of a seat card: the logo of the seat, its name, what it lets the member do, and
 * whatever the card tells about the seat in its corner. Every place that shows a seat as a card
 * uses it, so that a seat looks the same wherever it is shown.
 */
export function SeatCardContent(t0) {
  const $ = _c(26);
  const {
    seat,
    isCheckboxLabel: t1,
    isLogoFaded: t2,
    corner,
    description,
    children
  } = t0;
  const isCheckboxLabel = t1 === undefined ? false : t1;
  const isLogoFaded = t2 === undefined ? false : t2;
  const Logo = SEAT_LOGOS[seat];
  const t3 = isCheckboxLabel ? CHECKBOX_ALIGNMENT_OFFSET : 0;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      gap: 1.5,
      pt: t3,
      width: "100%"
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = isLogoFaded ? FADED_LOGO_OPACITY : 1;
  let t6;
  if ($[2] !== t5) {
    t6 = {
      display: "block",
      flexShrink: 0,
      opacity: t5
    };
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== Logo || $[5] !== t6) {
    t7 = <Logo height={LOGO_SIZE} width={LOGO_SIZE} aria-hidden={true} style={t6} />;
    $[4] = Logo;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      flex: 1,
      minWidth: 0
    };
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      gap: 1,
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      lineHeight: LOGO_SIZE
    };
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const t11 = MEMBER_SEAT_LABELS[seat];
  let t12;
  if ($[10] !== t11) {
    t12 = <Text variant="heading14" component="span" sx={t10}>{t11} seat</Text>;
    $[10] = t11;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== corner || $[13] !== t12) {
    t13 = <Stack direction="row" component="span" sx={t9}>{t12}{corner}</Stack>;
    $[12] = corner;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      color: "text.secondary"
    };
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  const t15 = description ?? MEMBER_SEAT_DESCRIPTIONS[seat];
  let t16;
  if ($[16] !== t15) {
    t16 = <Text variant="bodyS" component="span" sx={t14}>{t15}</Text>;
    $[16] = t15;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== children || $[19] !== t13 || $[20] !== t16) {
    t17 = <Stack component="span" sx={t8}>{t13}{t16}{children}</Stack>;
    $[18] = children;
    $[19] = t13;
    $[20] = t16;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== t17 || $[23] !== t4 || $[24] !== t7) {
    t18 = <Stack direction="row" component="span" sx={t4}>{t7}{t17}</Stack>;
    $[22] = t17;
    $[23] = t4;
    $[24] = t7;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  return t18;
}